import { render, staticRenderFns } from "./AnalystRatingDetail.vue?vue&type=template&id=51a8c448&"
import script from "./AnalystRatingDetail.vue?vue&type=script&lang=js&"
export * from "./AnalystRatingDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnalystRatingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-analyst-rating/src/components/analystRating/AnalystRatingDetail.vue"
export default component.exports